<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد رزرو
        </b-button>
      </b-col>
    </b-row>
    <div v-if="transactions">
      <div class="d-flex justify-content-between align-items-center">
        <per-page v-model="perPage" class="w-50" />
      </div>
      <b-row>
        <!--        <b-col sm="6" md="3" lg="2">
                  <per-page v-model="perPage" class="w-100" />
                </b-col>-->
        <b-col sm="12" md="7" lg="8">
          <search-reservations
              @searchBase="searchBase"
              :selectedFilter="selectedFilter"
              :submitLoading="searchBasesubmitLoading"
              :isSearchResult="isSearchResult"
              ref="ownersSearchComponent"
              class="w-100"
              v-model="searchInput"
          />
        </b-col>
      </b-row>

      <b-card body-class="p-0" class="mt-1">
        <table-head
          ref="transactionsTableHeadComponent"
          :items="tableHeadings"
          @sort="sort"
        />
        <b-row
          class="py-1 mx-1 border-bottom"
          v-for="transaction in transactions"
          :key="transaction.id"
        >
          <b-col
            class="d-flex align-items-center pl-0"
            v-if="transaction.order.residence"
          >
            {{ transaction.order.code }}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <router-link
              :to="{
                name: 'calender',
                params: { id: transaction.order.residence.id },
              }"
              variant="flat-secondary"
              class="font-weight-bolder btn"
            >
              <BIconCalendar />
            </router-link>
            <!--            <img :src="$http.defaults.fileUrl+'/'+transaction.order.residence.images[0].path.original" alt="" style="width: 50px;height: 50px">-->
            <a
              target="_blank"
              :href="
                'https://roomtoor.com/space/' +
                transaction.order.residence.category.slug +
                '-' +
                transaction.order.residence.code
              "
            >
              {{ transaction.order.residence.name }}
            </a>
          </b-col>
          <b-col
            class="d-flex align-items-center pl-0"
            v-if="transaction.order.residence.host.full_name"
          >
            {{ transaction.order.residence.host.full_name }}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <div>
              <span> {{ transaction.user.full_name }}</span>

              <br />
              <b-badge variant="primary" style="direction: ltr">
                {{ transaction.user.mobile.replace("+98", "0") }}
              </b-badge>
            </div>
          </b-col>
          <b-col
            class="d-flex align-items-center pl-0"
            v-if="transaction.order"
          >
            <div>
              <span>تاریخ ورود : </span>
              <b-badge variant="info" v-if="transaction.order.checkin">
                {{
                  new Date(transaction.order.checkin)
                    .toLocaleString("fa-IR")
                    .split(",")[0]
                }}
              </b-badge>
              <br />
              <span>تاریخ خروج : </span>
              <b-badge variant="info" v-if="transaction.order.checkout">
                {{
                  new Date(transaction.order.checkout)
                    .toLocaleString("fa-IR")
                    .split(",")[0]
                }}
              </b-badge>
              <br />
              <span>تعداد شب : </span>
              <b-badge variant="info" v-if="transaction.order.checkout">
                {{ transaction.order.duration }} شب
              </b-badge>
              <br />
              <span>تعداد مهمان ها : </span>
              <b-badge variant="info" v-if="transaction.order.guests">
                {{ transaction.order.guests.adult }} نفر بزرگسال
              </b-badge>
              <b-badge
                variant="info"
                style="margin: 0 2px"
                v-if="transaction.order.guests.adult"
              >
                {{ transaction.order.guests.adult }} نفر کودک
              </b-badge>
              <b-badge variant="info" v-if="transaction.order.guests.baby">
                {{ transaction.order.guests.baby }} نفر نوزاد
              </b-badge>
              <b-badge
                variant="info"
                style="margin: 0 2px"
                v-if="transaction.order.guests.pet"
              >
                {{ transaction.order.guests.pet }} حیوان
              </b-badge>
            </div>
          </b-col>

          <b-col
            class="d-flex align-items-center pl-0"
            v-if="transaction.order"
          >
            <div v-if="transaction.order.prices">
              <span>مجموع هزینه خدمات : </span>
              <b-badge variant="dark" v-if="transaction.order.prices">
                {{ transaction.order.prices.service_price }} تومان
              </b-badge>
              <br />
              <span>هزینه نوزاد : </span>
              <b-badge variant="dark">
                <span v-if="transaction.order.prices.baby_price > 0">
                  {{ transaction.order.prices.baby_price }} تومان
                </span>
                <span v-else> 0 </span>
              </b-badge>
              <br />
              <span>هزینه حیوان : </span>
              <b-badge variant="dark">
                <span v-if="transaction.order.prices.pet_price > 0">
                  {{ transaction.order.prices.pet_price }} تومان
                </span>
                <span v-else> 0 </span>
              </b-badge>
              <br />
              <span>مجموع پرداختی : </span>
              <b-badge variant="dark" v-if="transaction.paid">
                <!--                {{  formatnumber(transaction.paid)}} تومان-->
                {{ transaction.paid }} تومان
              </b-badge>
              <br />
              <span>کمیسیون سایت (10 درصد) : </span>
              <b-badge variant="dark" v-if="transaction.commission_price">
                <!--                {{ formatnumber(transaction.commission_price)}} تومان-->
                {{ transaction.commission_price }} تومان
              </b-badge>
            </div>
          </b-col>

          <b-col
            class="d-flex align-items-center"
            v-if="transaction.service_type"
          >
            <b-badge
              variant="success"
              class="badge-glow"
              v-if="transaction.service_type === 'manual'"
            >
              پرداخت در محل
            </b-badge>
            <b-badge
              variant="success"
              class="badge-glow"
              v-if="transaction.service_type === 'gateway'"
            >
              آنلاین
            </b-badge>
            <b-badge
              variant="success"
              class="badge-glow"
              v-if="transaction.service_type === 'card'"
            >
              کارت به کارت
            </b-badge>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <b-badge
              variant="success"
              class="badge-glow"
              v-if="transaction.status === 'success'"
            >
              پرداخت موفق
            </b-badge>
            <b-badge
              variant="danger"
              class="badge-glow"
              v-if="transaction.status === 'fail'"
            >
              پرداخت ناموفق
            </b-badge>
            <div v-if="transaction.status === 'pending'">
              <b-badge
                variant="warning"
                class="badge-glow mt-1"
                v-if="transaction.status === 'pending'"
              >
                اومده خرید
              </b-badge>
              <b-badge
                variant="warning"
                class="badge-glow mt-1"
                v-if="transaction.status === 'pending'"
              >
                اومده تست کنه
              </b-badge>
              <b-badge
                variant="warning"
                class="badge-glow mt-1"
                v-if="transaction.status === 'pending'"
              >
                منتظر تایید میزبانه
              </b-badge>
            </div>
          </b-col>
          <b-col
            class="d-flex align-items-center flex-row-reverse"
            style="direction: ltr"
          >
            {{
              new Date(transaction.created_at).toLocaleString("fa-IR", {
                timeZone: "Iran",
              })
            }}
          </b-col>
          <b-col class="d-flex align-items-center">
            <b-button
              variant="flat-info"
              v-if="transaction.status === 'success'"
              class="font-weight-bolder"
              @click="showFormModal(transaction, 'document')"
            >
              <BIconFiles font-scale="1" />
            </b-button>

            <b-button variant="flat-info" class="font-weight-bolder">
              <feather-icon icon="EyeIcon" size="20" />
            </b-button>
            <b-button
              @click="showConfirmModal(transaction)"
              variant="flat-danger"
              class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
            <b-button
              @click="showFormModal(transaction)"
              variant="flat-secondary"
              class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <pagination
        ref="transactionsPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="500px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div v-if="formType == 'document'" class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{
                editMode
                  ? "ویرایش سند تسویه حساب با میزبان"
                  : "ایجاد سند تسویه حساب با میزبان"
              }}
            </h3>
          </div>
          <div v-else class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش رزرو" : "ایجاد رزرو" }}
            </h3>
          </div>
        </div>
      </template>

      <b-container v-if="formType == 'document'" class="">
        <b-form-group class="mt-3">
          <label for="document_name" class="text-capitalize"
            >{{ $t("document_name") }}:</label
          >
          <b-form-input
            id="document_name"
            v-model="documentInput.name"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-3">
          <label for="document_pric" class="text-capitalize"
            >{{ $t("document_pric") }}:</label
          >
          <b-form-input
            id="document_pric"
            v-model="documentInput.price"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-3">
          <label for="bank_tracking_code" class="text-capitalize"
            >{{ $t("bank_tracking_code") }}:</label
          >
          <b-form-input
            id="bank_tracking_code"
            v-model="documentInput.bank_tracking_number"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-3">
          <label for="document_desc" class="text-capitalize"
            >{{ $t("document_desc") }}:</label
          >
          <b-form-input
            id="document_desc"
            v-model="documentInput.document_desc"
            type="text"
          />
        </b-form-group>


       

        <label for="document_medias" class="text-capitalize mb-3"
          >{{ $t("document_medias") }}:</label
        >
        <div
          v-for="(file, index) in documentInput.medias"
          :key="'file_' + index"
          class="w-100 d-flex"
        >
          <b-form-file
            accept=".zip,.rar,.7zip"
            v-model="documentInput.medias[index]"
            ref="file-input"
          ></b-form-file>
          <!-- <b-button variant="flat-danger"   @click="removeFile(index)"> <feather-icon icon="Trash2Icon" size="20" /></b-button> -->
        </div>
         <b-button v-if="documentInput.mediaPath" block mt-2 variant="outline-primary">دانلود اسناد بارگذاری شده</b-button>
        <!-- <b-button @click="addNewFile" >افزودن سند دیگر</b-button> -->
      </b-container>

      <b-container v-else class="">
        <b-form-group class="mt-3">
          <label for="transaction_name" class="text-capitalize"
            >{{ $t("first name") }}:</label
          >
          <b-form-input
            id="transaction_name"
            v-model="transactionInput.name"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="transaction_slug" class="text-capitalize"
            >اسلاگ| slug:</label
          >
          <b-form-input
            id="transaction_slug"
            v-model="transactionInput.slug"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-1" v-slot="{ ariaDescribedby }">
          <label for="transaction_status" class="text-capitalize">
            وضعیت :
          </label>
          <b-form-radio
            v-model="transactionInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            >فعال</b-form-radio
          >
          <b-form-radio
            v-model="transactionInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            >پیش نویس</b-form-radio
          >
        </b-form-group>
      </b-container>

      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
  BBadge,
  BIconCalendar,
  BIconFiles,
  BFormFile,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import SearchReservations from "@/components/SearchReservations.vue";

export default {
  components: {
    SearchReservations,
    BIconCalendar,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    BIconFiles,
    VueUploadMultipleImage,
    BFormFile,
  },
  data() {
    return {
      isSearchResult:false,
      selectedFilter:[],
      formType: "document",
      perPage: 10,
      page: 1,
      transactions: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "کد رزرو",
          slug: "code",
          sortable: true,
        },
        {
          title: " عنوان ",
          slug: "title",
          sortable: true,
        },
        {
          title: " میزبان ",
          slug: "host",
          sortable: true,
        },
        {
          title: " مهمان ",
          slug: "guest",
          sortable: true,
        },
        {
          title: " سفارش ",
          slug: "order",
          sortable: true,
        },
        {
          title: " هزینه ",
          slug: "price",
          sortable: true,
        },
        {
          title: " نوع پرداخت ",
          slug: "service_type",
          sortable: true,
        },
        {
          title: " وضعیت ",
          slug: "created_at",
          sortable: true,
        },
        {
          title: " تاریخ درخواست ",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      transactionInput: {
        name: "",
        slug: "",
        status: "active",
      },
      documentInput: {
        user_id: "",
        order_id: "",
        name: "",
        price: "",
        bank_tracking_number: "",
        document_desc: "",
        medias: [[]],
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getReservations();
    // this.getCompanies();
    this.getUrlParams();
  },
  
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getReservations();
    },
    perPage(value) {
      this.page = 1;
      this.getReservations();
    },
    page(value) {
      this.getReservations();
    },
  },
  methods: {
    getUrlParams() {
      if ("filter[service_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[service_name]`];
        this.selectedFilter.push("service_name");
      }
      if ("filter[status]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[status]`];
        this.selectedFilter.push("status");
      }
      if ("filter[host_mobile]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host_mobile]`];
        this.selectedFilter.push("host_mobile");
      }
      if ("filter[host_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host_name]`];
        this.selectedFilter.push("host_name");
      }
      if ("per_page" in this.$route.query) {
        this.perPage = Number(this.$route.query[`per_page`]);
        this.$refs.userPerPageComponent.perPage = this.perPage;
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }

    },
    searchBase(data) {
      console.log("data", data);
      this.selectedFilter = [];
      if (data.selectedFilter.length > 0) {
        data.selectedFilter.forEach((item) => {
          if (item == "service_name") {
            this.searchInput = data.searchInput;
          } else if (item == "status") {
            this.searchInput = data.searchInput;
          } else if (item == "host_mobile") {
            this.searchInput = data.searchInput;
          }
          else if (item == "host_name") {
            this.searchInput = data.searchInput;
          }
        });
        this.selectedFilter = data.selectedFilter;
      }
      this.searchBasesubmitLoading = true;
      if (this.searchInput) {
        this.isSearchResult = true;
      }
      if (data.type == "delete") {
        this.isSearchResult = false;
      }
      this.getReservations();
    },

    addNewFile() {
      this.documentInput.medias.push([]);
    },

    removeFile(index) {
      this.documentInput.medias.splice(index, 1);
    },
    formatnumber(newValue) {
      const result = newValue
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getReservations();
    },

    async getReservations() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        "filter[service_name]": this.selectedFilter.includes("service_name")
            ? this.searchInput
            : "",
        "filter[status]": this.selectedFilter.includes("status")
            ? this.searchInput
            : "",
        "filter[host_mobile]": this.selectedFilter.includes("host_mobile")
            ? this.searchInput
            : "",
        "filter[host_name]": this.selectedFilter.includes("host_name")
            ? this.searchInput
            : "",

        paginate: true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/transactions?per_page=20&filter[orderable_type]=residence",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.transactions = data.data;
          this.paginationData = data.meta;
          this.searchBasesubmitLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.searchBasesubmitLoading = false;
        });
    },
    showConfirmModal(transaction) {
      this.$bvModal
        .msgBoxConfirm(
          "آیا از حذف رزرو مطمئن هستید ؟" + `: ${transaction.payment_id}.`,
          {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (confirmed) => {
          if (confirmed) {
            let transactionIndex = 0;
            this.transactions = await this.transactions.filter(
              (transactionItem, index) => {
                if (transactionItem.id == transaction.id) {
                  transactionIndex = index;
                }
                return transactionItem.id !== transaction.id;
              }
            );

            const requestData = {
              method: "delete",
              url: `/admin/transactions/${transaction.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(
                  `رزرو: ${transaction.payment_id} با موفقیت حذف شد.`,
                  {
                    title: this.$t("Done"),
                    variant: "success",
                    solid: true,
                  }
                );
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.transactions.splice(transactionIndex, 0, transaction);
              });
          }
        });
    },
    showFormModal(transaction, type) {
      if (type == "document") {
        this.formType = "document";
        this.editMode = true;
        this.documentInput = {
            name: transaction.document_name,
            price:transaction.document_price,
            bank_tracking_number:transaction.bank_tracking_number,
             document_desc:transaction.document_desc,
              medias: [[]],
              mediaPath:transaction.document_media.path

          };
         this.transactionInput = {
            id: transaction.id,
            name: transaction.name,
            slug: transaction.slug,
            status: transaction.status,
          };
      } else {
        this.formType = "mainTransationInfo";
        if (transaction) {
          this.transactionInput = {
            id: transaction.id,
            name: transaction.name,
            slug: transaction.slug,
            status: transaction.status,
          };
          this.editMode = true;
        } else {
          this.transactionInput = {
            name: "",
            slug: "",
            status: "active",
          };
          this.editMode = false;
        }
      }
      this.formModal = true;
    },
    submitForm() {
      this.submitLoading = true;
      let formData = new FormData();
      if (this.formType == "document") {
        formData.append("document_name", this.documentInput.name);
        formData.append("document_price", this.documentInput.price);

        formData.append(
          "bank_tracking_number",
          this.documentInput.bank_tracking_number
        );
        formData.append("document_media", this.documentInput.medias[0]);
        formData.append("document_desc", this.documentInput.document_desc);
      }

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
          ? `/admin/transactions/update/${this.transactionInput.id}`
          : `/admin/transactions`,
        data: this.formType == "document" ? formData : this.transactionInput,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "رزرو با موفقیت اضافه شد";
          if (this.editMode) message = "رزرو با موفقیت ویرایش شد";
          if(this.formType == 'document')  message = "سند میزبان با موفقیت اضافه شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (
            !this.editMode &&
            this.transactions &&
            this.transactions.length > 0
          ) {
            this.$refs.transactionsPaginationComponent.clear();
            // this.$refs.transactionsSearchComponent.clear();
            this.$refs.transactionsTableHeadComponent.clear();
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }

          this.submitLoading = false;
          this.formModal = false;
          this.getReservations();
        })
        .catch((err) => {
          let message = "خطا در ایجاد رزرو";
          if (this.editMode) message = "خطا در ویرایش رزرو";
          if(this.formType == 'document')  message = "خطا در ایجاد سند";
          if (err.response && err.response.data && err.response.data.message)
            message = err.response.data.message;

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>


